import React from "react";

import * as S from "./styles";
import iconWarningGold from "../../assets/icons/icon-warning-gold.svg";

const WarningBannerAssignature = ({ boldText, text, buttonText, onButtonClick, maxWidth }) => (
  <S.WarningBanner maxWidth={maxWidth}>
    <img src={iconWarningGold} alt="" />

    <div className="warning-content">
      <p>
        <b>{boldText}</b> <span style={{ color: "#e0a408" }}>{text}</span>
      </p>

      <button type="button" style={{ cursor: "pointer" }} onClick={onButtonClick}>
        <b style={{ cursor: "pointer" }}>{buttonText}</b>
      </button>
    </div>
  </S.WarningBanner>
);

export default WarningBannerAssignature;
